
import { Component, Vue } from 'vue-property-decorator'
import { CommonService, MediaService } from '@/services'
import FullLoading from '@/components/full_loading/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import { pick } from 'lodash'

const typeObj = { url: 1, xpath: 2, api: 3 }
const configType = [
    { value: typeObj.url, name: '只提供网址' },
    { value: typeObj.xpath, name: 'xpath' },
    { value: typeObj.api, name: 'api' }
]
// 参数映射，针对不同类型过滤不同参数
const paramsMap = {
    public: ['medium_id', 'type', 'task_name', 'url', 'remarks'],
    [typeObj.url]: [],
    [typeObj.xpath]: ['article_xpath', 'title_xpath', 'publishedat_xpath', 'coverimg_xpath', 'content_xpath', 'originurl_xpath','reporter_xpath','source_xpath','formdata'],
    [typeObj.api]: ['content_xpath', 'lists_name', 'title_name', 'originurl_name', 'publishedat_name', 'coverimg_name','reporter_xpath','source_xpath','formdata']
}

@Component({
    name: 'createMediaSplider',
    components: {
        FullLoading,
        CreateDetailLayout
    }
})
export default class extends Vue {
    private isLoading = true
    private createLoading = false
    private mediaQuery = ''
    private config = {
        medium_id: '',
        task_name: '',
        type: 1,
        url: '',
        originurl_xpath: '',
        article_xpath: '',
        title_xpath: '',
        publishedat_xpath: '',
        coverimg_xpath: '',
        content_xpath: '',
        reporter_xpath: '',
        formdata: '',
        source_xpath: '',
        title_name: '',
        lists_name: '',
        originurl_name: '',
        publishedat_name: '',
        coverimg_name: '',
        remarks: ''
    }
    private typeObj = typeObj
    private configType = configType

    created() {
        this.$title('创建媒体定制爬虫 - 庖丁')
    }

    async mounted() {
        this.isLoading = false
    }

    // 判断是否显示
    isShow(type: number | number[]) {
        if (Array.isArray(type)) {
            return type.includes(this.config.type)
        }
        return type === this.config.type
    }

    // 搜索媒体
    async onSearchMedia(query: string, callback: any) {
        if (!query) return callback([])
        const result = await MediaService.searchMedia({ value: query })
        if (result.status === 200) {
            return callback(result.data)
        }
        return callback([])
    }
    // 选择媒体
    onSelectMedia(val: any) {
        this.config.medium_id = val.id
    }
    // 清空媒体
    onMediaClear() {
        this.config.medium_id = ''
    }
    // 重置输入框
    onReset() {
        Object.keys(this.config).forEach(key => {
            if (key !== 'type') {
                Reflect.set(this.config, key, '')
            }
        })
        this.mediaQuery = ''
        this.$msuccess('重置成功')
    }
    // 创建配置
    onCreateConfig() {
        if (!this.config.medium_id) {
            return this.$mwarning('请先选择媒体')
        }
        this.$confirm('是否确认创建该爬虫配置?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.createLoading = true
            const params = {
                ...pick(this.config, paramsMap.public),
                ...pick(this.config, paramsMap[this.config.type]),
                url: this.config.url.split(',').map(n => n.replace('\n', '').trim())
            }
            const result = await CommonService.createSpiderConfig(params)
            this.createLoading = false
            if (result.status === 200) {
                return this.$msuccess('创建成功')
            }
            this.$merror(result.message || '发生错误, 请稍后再试')
        }).catch(() => {
            // type url     ☑️
            // type xpath   ☑️
            // type api     ☑️       
        })
    }
}
